import React from "react";
//#region types
import { ComponentBaseProps } from "models/propTypes/basePropTypes";
//#endregion
//#region components
import { Skeleton } from "@mui/material";
import Lottie from "lottie-react";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import logoLottie from "images/lottie-w-blue.json";

const LoadingWithLogo: React.FC<ComponentBaseProps> = (props) => {
  return (
    <Skeleton className={clsx(cssExports.loadingWithLogo, props.className)}>
      <Lottie className={cssExports.player} animationData={logoLottie} autoplay loop />
    </Skeleton>
  );
};

export default LoadingWithLogo;
